import { useState, useEffect } from "react";
import Api from "../../components/api/Api";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Notification, {showToast,} from "../../../components/common/notification/Notification";
import { Link, useNavigate, useParams } from "react-router-dom";
import Spinner from "../../../components/common/spinner/Spinner";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
// eslint-disable-next-line no-unused-vars
import axios from "axios";
import { useSelector } from "react-redux";

const EditLocalBazaar = () => {
  const navigate = useNavigate();
  const { Id } = useParams();
  const loggedInUser = useSelector((state) => state.auth.user);
  // eslint-disable-next-line no-unused-vars
  const token = loggedInUser?.refreshToken;
  // eslint-disable-next-line no-unused-vars
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const editAllServices = Api({
    url: `api/local/bazaar/categories/update`,
  });
 
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isError, setIsError] = useState(false);
 
  const getAllServices = Api({
    url: `api/local/bazaar/categories/view/${Id}`,
  });
  const [formData, setFormData] = useState({});

  useEffect(() => {
    const fetchPostData = async () => {
      try {
        setIsLoading(true);
        const response = await getAllServices.fetchDataBySingleId(true);
        // console.log(response)
        if (response?.data?.statusType === "SUCCESS") {
          const postData = response.data.localBazaarCategory;

          setFormData({
            id: Id,
            name: postData.name,
            description: postData.description,
          });
        }
      } catch (error) {
        setIsError(true);
        console.error(error);
        showToast("Error Occurred", { type: "error" });
      } finally {
        setIsLoading(false);
      }
    };

    fetchPostData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setIsLoading(true);
      console.log(formData);

      const responseData = await editAllServices.editData(formData);
      // const responseData = await axios.post(
      //   `${baseUrl}/api/all/services/types/update/${Id}`,
      //   formData,
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: `Bearer ${token}`,
      //     },
      //   }
      // );
      console.log("API DATA:", responseData.data);
      if (responseData.data.statusType === "SUCCESS") {
        showToast("Local Bazaar updated successfully", { type: "success" });
        setTimeout(() => {
          navigate("/local-bazaar");
        }, 3000);
      }else{
        showToast("update failed", {type: "error"});
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
      showToast("Error Occurred", { type: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "Local Bazaar", link: "/local-bazaar" },
    { label: "Edit Local Bazaar", link: "", active: true },
  ];

  return (
    <>
      <Notification />
      <Container>
        <BreadCrumb items={breadcrumbItems} />
        <Row>
          <Col lg={12} md={12} sm={12}>
            <SingleDetailHeader
              header="Edit Local Bazaar Details"
              description="Edit Local Bazaar details section"
            />
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={12}>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Enter Name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </div>
                </Col>
                <Col md={12}>
                  <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Description
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="description" 
                      placeholder="Enter description"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                    />
                  </div>
                </Col>
              </Row>

              <Button variant="primary" type="submit" className="mt-5 mb-5">
                {isLoading ? <Spinner loading={true} /> : "Update"}
              </Button>
              <Link
                style={{ marginLeft: "1rem" }}
                className="btn btn-primary mb-5 mt-5"
                to={"/local-bazaar"}
              >
                Back
              </Link>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EditLocalBazaar;